<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 품번 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 품명 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000957')"
						paramKey="partNm"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.partNm"
					>
					</search-input>
				</el-col>
				<!-- PPR번호 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001034')"
						paramKey="pprNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.pprNo"
					>
					</search-input>
				</el-col>
				<!-- 소싱구분 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000981')"
						paramKey="partGCd"
						:options="getPartGCdList_"
						:propData="searchParams.partGCd"
						@commChange="setSearchParam_Pgs"
					></select-combo>
				</el-col>
				<!-- 진행상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001094')"
						paramKey="pgsStCd"
						:options="isChkPartGCd()"
						:propData="searchParams.pgsStCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.cofNm"
						@keyup.native.delete="() => onCofCdInPutKeyDown('cofCd')"
						:readonly="!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp|| this.flgPqypoGrp||this.flgHmcrdGrp||this.flgPqylpGrp||this.flgPqyipGrp)"
						:iconReadonly="!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp|| this.flgPqypoGrp||this.flgHmcrdGrp||this.flgPqylpGrp||this.flgPqyipGrp)"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onCofPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 발생일자 -->
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001032') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							value-format="yyyyMMdd"
						/>
					</div>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button
					line
					icon="search"
					:onClick="searchList"
					v-if="(isButton_(scrId, 'CR') && (flgPqyrgGrp || flgPqyrvGrp || flgPqyapGrp || flgPqycpGrp||flgPqypoGrp || flgHmcrdGrp||flgPqylpGrp|| flgPqyipGrp)) || flgOsGrp"
				>
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId" />
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId" />
		<!-- <pqy-comp-popup ref="pqyCompPopup" @SendData="pqyCpnyData" :scrId="scrId"></pqy-comp-popup> -->
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PrtRpt/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
// import pqyCompPopup from '@qms/comm/commpopup/PqyCpnyPopup/PqyCpnyPopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false }, // 총괄 관리자그룹
		flgPqyapGrp: { type: Boolean, default: false }, // 승인자그룹
		flgPqyrvGrp: { type: Boolean, default: false }, //검토자 그룹
		flgPqyrgGrp: { type: Boolean, default: false }, //작성자 그룹
		flgPqycpGrp: { type: Boolean, default: false } ,//외부업체 그룹
		flgPqypoGrp: { type: Boolean, default: false } ,
		flgHmcrdGrp: { type: Boolean, default: false },
		flgPqylpGrp: { type: Boolean, default: false } ,
		flgPqyipGrp: { type: Boolean, default: false } 
	},
	data() {
		return {
			searchDateRange: ['', ''],
			selBoxKd: false,
			selBoxLp: true
		};
	},
	components: { SearchInput, PartMngPopup, SelectCombo, CompPopup },
	async created() {
		try {
			this.searchDateRange = [...this.getSearchMonths_];
			await this.getCommCodes_({ key: 'pgsStPcCdList', codeType: 'PGS_ST_PC' }); //부품검사 진행상태;
			const cpnyUser = !!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp||this.flgPqypoGrp||this.flgHmcrdGrp||this.flgPqylpGrp||this.flgPqyipGrp);
			if (!cpnyUser && this.flgPqycpGrp) {
				const { cpnyCd, cpnyNm, partnerYn } = await this.getPartnerInfo_();
				if (!partnerYn || partnerYn === 'N')
					throw new Error(this.getMessage_('QWCC001885')); //사용자의 업체 정보를 불러올 수 없습니다. 관리자에게 문의하세요.
				else {
					this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
					this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
				}
			}
			const result = await this.searchList();
			this.setState_({ key: 'feTarget', value: result.feTarget });
			this.setState_({ key: 'ubiTarget', value: result.ubiTarget });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error.message || error });
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		setSearchParam_Pgs(param) {
			this.isChkPartGCd();
			this.setSearchParam_({ key: 'pgsStCd', value: '' });
			this.setSearchParam_(param);
		},
		isChkPartGCd() {
			const partGCd = this.searchParams.partGCd;
			if (partGCd === 'K') {
				return this.getPgsStKdCdList_;
			} else {
				return this.getPgsStLpCdList_;
			}
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				let isAuth ='';
				if(this.flgPqylpGrp){
					isAuth = 'V';
				}
				return await this.getPrtRptList_({isAuth});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		//불량보고 번호조회 팝업 오픈
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		//협력사 팝업조회
		onCofPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		onCofCdInPutKeyDown(key) {
			this.setSearchParam_({ key: key, value: '' });
		},
		sendData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
		}
	},
	computed: { ...rootComputed, ...qmsComputed, ...serviceComputed }
};
</script>

<style></style>
